import { render, staticRenderFns } from "./tableExportDiscount.vue?vue&type=template&id=05033dd8&"
import script from "./tableExportDiscount.vue?vue&type=script&lang=js&"
export * from "./tableExportDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports